<template>
    <v-card class="flight-card" :class="{ 'flight-card-selected': isFlightSelected(flight) }">
        <v-card-text>
            <v-layout row wrap align-flex-start>
                <!-- Flight Segments Details -->
                <v-flex xs12 sm9 md10 class="flight-info">
                    <!-- Segments -->
                    <div class="segments-container">
                        <div v-for="(journey, jIndex) in journeys" :key="jIndex" :class="{'mt-2 pt-2 border-top': jIndex > 0}">
                            <div v-if="journeys.length > 1" class="journey-title mb-1" style="color: #2196f3; font-size: 13px;">
                                <strong><v-icon small color="primary">{{ journey.direction == 0 ? 'flight_takeoff' : 'flight_land' }}</v-icon> {{ journey.direction == 0 ? 'Gidiş' : (journey.direction == 1 ? 'Dönüş' : 'Yön ' + journey.direction) }}</strong>
                            </div>
                            <v-layout row wrap align-center class="segment-layout">
                                <!-- Airline Info -->
                                <v-flex xs12 sm12 class="airline-section">
                                    <div class="airline-info">
                                        <span class="airline-name">{{ journey.firstSegment.MarkettingAirlineName
                                            }}</span>

                                        <span class="flight-number ml-2">
                                            {{ journey.flightNumbers }}
                                        </span>
                                    </div>
                                </v-flex>

                                <!-- Journey Section (Horizontal) -->
                                <v-flex xs12 sm7 class="journey-section">
                                    <v-layout row wrap align-center class="journey-layout">
                                        <v-img :src="getImgUrl(journey.firstSegment.MarkettingAirline)" alt="K" height="65px"
                                            width="85px" contain>
                                        </v-img>
                                        <!-- Departure -->
                                        <v-flex xs12 sm2 class="journey-point">
                                            <div class="airport-time">
                                                <span class="airport-code">{{
                                                    journey.firstSegment.DepartureAirportCode
                                                    }}</span>
                                                <span class="time">{{ journey.firstSegment.DepartureTime }}</span>
                                            </div>
                                            <div class="airport-name">
                                                {{ journey.firstSegment.DepartureCityName }}
                                            </div>
                                            <div class="airport-small">
                                                {{ journey.firstSegment.DepartureAirportName }}
                                            </div>
                                        </v-flex>

                                        <!-- Duration & Equipment -->
                                        <v-flex xs12 sm3 class="duration-section">
                                            <div class="duration-info">
                                                <span class="duration">
                                                    <v-icon small>flight</v-icon>
                                                    {{ journey.formattedDuration }}
                                                </span>
                                                <span v-if="journey.isTransfer" class="transfer-badge" style="font-size: 11px; color: #f57c00; font-weight: bold; text-align: center;">
                                                    {{ journey.transferCount }} Aktarma
                                                    <div v-if="journey.transferAirports.length > 0" style="font-size: 10px; color: #757575; font-weight: normal; margin-top: 2px;">
                                                        ({{ journey.transferAirports.join(', ') }})
                                                    </div>
                                                </span>
                                                <span v-else class="transfer-badge" style="font-size: 11px; color: #4caf50; font-weight: bold;">
                                                    Direkt
                                                </span>
                                                <span v-if="journey.firstSegment.EquipmentType" class="equipment-info">
                                                    {{ journey.firstSegment.EquipmentType }}
                                                </span>
                                            </div>
                                        </v-flex>

                                        <!-- Arrival -->
                                        <v-flex xs12 sm3 class="journey-point">
                                            <div class="airport-time">
                                                <span class="airport-code">{{
                                                    journey.lastSegment.ArrivalAirportCode }}</span>
                                                <span class="time">{{ journey.lastSegment.ArrivalTime }}</span>
                                            </div>
                                            <div class="airport-name">
                                                {{ journey.lastSegment.ArrivalCityName }}
                                            </div>
                                            <div class="airport-small">
                                                {{ journey.lastSegment.ArrivalAirportName }}
                                            </div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>

                                <!-- Segment Details -->
                                <v-flex xs12 sm3 class="segment-details-section">
                                    <div class="segment-details">
                                        <span class="detail-item">
                                            <v-icon x-small>domain</v-icon>
                                            {{ $t('flight.cabin') || 'Cabin' }}: {{ journey.firstSegment.CabinType }}
                                        </span>
                                        <span class="detail-item">
                                            <v-icon x-small>info</v-icon>
                                            Branded Fares / {{
                                                journey.firstSegment.BookingClass
                                            }}
                                        </span>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </div>
                    </div>
                </v-flex>
                <v-flex xs12 sm3 md2 class="select-button-container">
                    <v-chip
                        v-if="flight.FlightSegments[0].Provider === 'Turna' || flight.FlightSegments[0].Provider === 'Amadeus' || flight.FlightSegments[0].Provider === 'Paximum'"
                        color="primary" text-color="white" class="mr-2">{{
                            flight.FlightSegments[0].Provider }}</v-chip>
                    <span class="headline" v-if="displayTotalFare > 0">{{
                        Number(displayTotalFare).toFixed(2) }} {{ currency }} </span>
                    <v-btn small :color="isFlightSelected(flight) ? 'success' : 'primary'"
                        @click="select(flight, index)" class="select-btn">
                        <v-icon left x-small v-if="isFlightSelected(flight)">check_circle</v-icon>
                        {{ isFlightSelected(flight) ? ($t('flight.selected') || 'Selected') :
                            ($t('flight.select') || 'Select') }}
                    </v-btn>
                    <v-btn small outline color="secondary" class="ml-2" @click="toggleDetails(index)">
                        {{ $t('flight.details') || 'Details' }}
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
import logoo from "../../../../../../assets/control";
import { resolveTotalFare, groupFaresByCode } from "./fareCurrency";
export default {
    name: "FlightInfo",
    props: {
        flight: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        currency: {
            type: String,
            default: 'TRY',
        }
    },
    computed: {
        displayTotalFare() {
            if (this.flight.SelectableFares && this.flight.SelectableFares.length > 0) {
                const grouped = groupFaresByCode(this.flight.SelectableFares);
                return resolveTotalFare(grouped[0], this.currency);
            }
            return resolveTotalFare(this.flight, this.currency);
        },
        journeys() {
            if (!this.flight || !this.flight.FlightSegments) return [];
            const groups = {};
            this.flight.FlightSegments.forEach(s => {
                const dir = s.DirectionInd != null ? s.DirectionInd : 0;
                if (!groups[dir]) groups[dir] = [];
                groups[dir].push(s);
            });
            
            return Object.keys(groups).sort().map(dir => {
                const segments = groups[dir];
                const firstSegment = segments[0];
                const lastSegment = segments[segments.length - 1];
                const isTransfer = segments.length > 1;
                const transferCount = segments.length - 1;
                const transferAirports = isTransfer ? segments.slice(0, -1).map(s => s.ArrivalAirportCode) : [];
                
                let formattedDuration = firstSegment.JourneyDuration;
                const totalMin = firstSegment.JourneyDurationInMinute;
                if (totalMin) {
                    const h = Math.floor(totalMin / 60);
                    const m = totalMin % 60;
                    let hStr = h > 0 ? `${h} sa` : '';
                    let mStr = m > 0 ? `${m} dk` : '';
                    formattedDuration = `${hStr} ${mStr}`.trim();
                }

                let flightNumbers = segments.length === 1 ? firstSegment.FlightNumber : `${firstSegment.FlightNumber} - ${lastSegment.FlightNumber}`;

                return {
                    direction: dir,
                    segments,
                    firstSegment,
                    lastSegment,
                    isTransfer,
                    transferCount,
                    transferAirports,
                    formattedDuration,
                    flightNumbers
                };
            });
        }
    },
    components: {

    },
    methods: {
        isFlightSelected(flight) {
            this.$emit("isFlightSelected", flight);
        },
        getImgUrl(img) {
            return logoo.logoControl(img);
        },
        toggleDetails() {
            this.$emit("toggleDetails", this.index);
        },
        select() {
            this.$emit("select", this.flight, this.index);
        }

    }
}
</script>
<style>
.flight-selection-wrapper {
    position: relative;
    width: 100%;
}


.flight-selection-container {
    position: relative;
    padding: 0;
}

.flight-item-wrapper {
    transition: opacity 0.3s ease, filter 0.3s ease;
    position: relative;
}

.flight-item-dimmed {
    opacity: 0.4;
    filter: grayscale(100%);
    pointer-events: none;
}

.flight-card {
    border-left: 4px solid #2196f3;
    transition: all 0.3s ease;
    background-color: #fafafa;
}

.flight-card:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.flight-card-selected {
    border-left-color: #4caf50;
    background-color: #f1f8e9;
    box-shadow: 0 2px 8px rgba(76, 175, 80, 0.2);
}

.flight-info {
    border-right: none;
    padding-right: 16px;
}

.segments-container {
    display: flex;
    flex-direction: column;
    gap: 0;
    width: 100%;
}

.segment {
    padding-bottom: 12px;
    position: relative;
}

.segment:not(:last-child) {
    padding-bottom: 16px;
}

.segment-layout {
    width: 100%;
}

.airline-section {
    margin-bottom: 8px;
    padding-bottom: 8px;
}

.airline-info {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: 1px solid #e0e0e0;
}

.airline-name {
    font-weight: 600;
    color: #333;
    font-size: 14px;
}

.flight-number {
    color: #666;
    font-size: 12px;
    margin-top: 2px;
}

.journey-section {
    margin-bottom: 12px;
}

.journey-layout {
    width: 100%;
    gap: 12px;
}

.journey-point {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.journey-info {
    margin: 8px 0;
}

.airport-time {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 2px;
}

.airport-code {
    font-weight: 600;
    color: #2196f3;
    font-size: 16px;
    min-width: 35px;
}

.time {
    color: #333;
    font-weight: 500;
    font-size: 14px;
}

.airport-name {
    color: #555;
    font-size: 12px;
    font-weight: 500;
}

.airport-small {
    color: #999;
    font-size: 11px;
    margin-top: 2px;
}

.duration-section {
    display: flex;
    justify-content: center;
    align-items: center;
}

.duration-info {
    margin: 0;
    padding: 0;
    border-top: none;
    border-bottom: none;
    display: flex;
    gap: 8px;
    align-items: center;
    flex-direction: column;
    text-align: center;
}

.duration {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    color: #666;
    font-size: 13px;
    font-weight: 500;
}

.equipment-info {
    display: inline-block;
    background-color: #f0f4ff;
    color: #1976d2;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 10px;
    font-weight: 500;
}

.segment-details-section {
    margin-top: 8px;
}

.segment-details {
    margin-top: 0;
    padding: 8px;
    background-color: #fafafa;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    gap: 12px;
    flex-wrap: wrap;
}

.detail-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: #666;
}

.segment-separator {
    position: relative;
    margin: 8px 0;
    text-align: center;
}

.separator-line {
    height: 2px;
    background: linear-gradient(90deg, transparent, #ddd, transparent);
    margin-bottom: 4px;
}

.separator-text {
    display: inline-block;
    background-color: #fafafa;
    padding: 0 8px;
    color: #f57c00;
    font-size: 11px;
    font-weight: 600;
}

.select-button-container {
    padding-left: 16px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
}

.select-btn {
    text-transform: uppercase;
    font-weight: 600;
    padding: 4px 12px !important;
    height: 32px !important;
    min-height: 32px !important;
    font-size: 12px !important;
}

.flight-meta {
    margin-top: 8px;
    text-align: center;
    color: #999;
}

@media (max-width: 960px) {
    .flight-info {
        border-right: none;
        border-bottom: 1px solid #eee;
        padding-right: 0;
        padding-bottom: 12px;
        margin-bottom: 12px;
    }

    .select-button-container {
        padding-left: 0;
        padding-top: 12px;
    }
}

.alternatives-container {
    margin-left: 8px;
    margin-right: 8px;
    margin-top: 0;
    border-top: 2px solid #e3e3e3;
    padding-top: 8px;
}

.alternatives-label {
    font-size: 12px;
    font-weight: 600;
    color: #ff9800;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0;
    padding: 8px 12px;
    background-color: #fff3e0;
    border-radius: 4px;
    cursor: pointer;
    user-select: none;
    transition: all 0.2s ease;
}

.alternatives-label:hover {
    background-color: #ffe0b2;
    color: #e65100;
}

.alternative-card {
    border-left: 4px solid #ff9800;
    background-color: #fffbf0;
}

.alternative-card:hover {
    box-shadow: 0 2px 8px rgba(255, 152, 0, 0.2);
}

.alternative-card.flight-card-selected {
    border-left-color: #4caf50;
    background-color: #f1f8e9;
    box-shadow: 0 2px 8px rgba(76, 175, 80, 0.2);
}

.alternatives-expanded {
    margin-top: 8px;
}
</style>